import colors from '../assets/styles/colors';

const getRandomColor = () => {
  const keys = Object.keys(colors);
  const randomNumber = Math.floor(Math.random() * keys.length);
  return colors[keys[randomNumber]];
};

export default getRandomColor;
